module.exports = __webpack_public_path__ + "static/media/asset_thumbsdown.5e766540.svg";